import cx from 'classnames'
import { FC, ReactNode } from 'react'

import * as styles from './Modal.scss'

interface ModalBodyProps {
  children: ReactNode
  className?: string
  noPadding?: boolean
}

const Body: FC<ModalBodyProps> = ({ children, className, noPadding = false }) => {
  const bodyClasses = cx(
    {
      [styles.Body]: true,
      [styles.BodyNoPadding]: noPadding,
    },
    className,
  )
  return <div className={bodyClasses}>{children}</div>
}

export default Body
